// React
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Card, Form, Modal, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

// Actions
import { deleteTechnicalAdviser } from '../../store/catalogs/TechnicalAdvisers/actions';
import { deleteUser } from '../../store/catalogs/Users/actions';

// Miscellaneous libraries
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { takeUntil } from 'rxjs';

// Custom Hooks and Services
import { useNotificationSelectedUsers } from './Hooks';
import { SharedNotificationService } from './Services';

// Components
import Table1 from '../../components/Common/TableContainer';
import { TableItemDeleteModal } from '../../components/Common/TableItemDeleteModal';

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const ProcessNotificationReactiveModal = ({
 props, setShowModal, showModal, modalHeader, modalClose,
 users, loading, total, currentPage, advisers, adviserTotal, adviserCurrentPage,
 onSearchTechAdvisors, onSearchOperatives, getPaginationOp, getPaginationTech
}) => {
  const {
    usersChecked,
    resetUsersArr,
    handleActionButtons,
  } = useNotificationSelectedUsers();

  const handleActionButtonsRef = useRef(handleActionButtons);
  useEffect(() => {
    handleActionButtonsRef.current = handleActionButtons;
  }, [handleActionButtons]);

  const stableHandleActionButtons = useCallback((row) => {
    handleActionButtonsRef.current(row);
  }, []);

  const [activeTab, setActiveTab] = useState('1');

  const profiletoggle = tab => {
  if (activeTab !== tab) setActiveTab(tab);
  }
  const className = props?.className ?? '';
 
  const [showModal2, setShowModal2] = useState(false);

  const [showModal4, setShowModal4] = useState(false);

  // Modal HOOKS
  const [rowInfo, setRowInfo] = useState();

  const [pivotOperatives, setPivotOperatives] = useState([]);
  const [pivotTechAdv, setPivotTechAdv] = useState([]);

  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    const mappedUsers = users.map(element => ({ ...element, checked: element.checked ?? false }));
    const mappedAdvisers = advisers.map(element => ({ ...element, checked: element.checked ?? false }));

    if (usersChecked?.length > 0) {
      usersChecked.forEach((element) => {
        const obj = mappedUsers.find(x => x.id === element.id);
        if (obj) obj.checked = true;
        const obj2 = mappedAdvisers.find(x => x.id === element.id);
        if (obj2) obj2.checked = true;
      });
    }

    setPivotOperatives(mappedUsers);
    setPivotTechAdv(mappedAdvisers);
  }, [users, advisers, usersChecked]);
  // * Redux fin

  const retrieveRowInfo2 = (values) => {
      console.log('Recuperado de la tabla', values);
  }

  const retrieveRowInfo = (values) => {
      console.log('Recuperado de la tabla', values);
  }

  const onClosed = (cancelProcess = false) => {
      setShowModal(false)
    if (cancelProcess) {
      resetUsersArr();
    }
      modalClose()
  }

  const onDeleteConfirmation = () => {
      if(activeTab === '1'){
          dispatch(deleteUser(rowInfo))
          setRowInfo('')
      } else{
          dispatch(deleteTechnicalAdviser(rowInfo))
          setRowInfo('')
      }
  }

  const columns2 = React.useMemo(
      () => [
          {
              Header: 'Nombre asesor técnico',
              width: '15%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{`${row.original.name ?? ''} ${row.original.surname ?? ''}`.trim() || '-'}</div>
                  </div>
              ),
          },
          {
            Header: 'Rol de usuario',
            width: '9%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.role ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Tipo de Usuario',
            width: '9%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.userType ?? '-'}</div>
                </div>
            ),
        },
          {
              Header: 'Firma del Asesor',
              width: '10%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.signature ?? '-'}</div>
                  </div>
              ),
          },
          {
              Header: 'E-mail',
              width: '9%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.email ?? '-'}</div>
                  </div>
              ),
          },
          {
            Header: 'Tipo de Laboratorio',
            width: '10%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.laboratoryType?.name ?? '-'}</div>
                </div>
            ),
          },
          {
            width: '10%',
            Header: "Acciones",
            Cell: ({ row }) => (
              <div className="page-title-box d-flex align-items-center justify-content-center">
                  <input
                    type="checkbox"
                    checked={row.original.checked ?? false}
                    className="form-check-input rounded-pill p-2"
                    onClick={ () => {
                      console.log("Tech Advisor checkbox clicked! Row:", row.original);
                      stableHandleActionButtons(row.original);
                    }}
                    onChange={() => {}}
                  />
              </div>
            ),
          },
      ],
      [stableHandleActionButtons]
  )
  
  //Data for the table header (Backend)
  const columns = React.useMemo(
      () => [
          {
              Header: 'Nombre',
              width: '14%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{`${row.original.name ?? ''} ${row.original.surname ?? ''}`.trim() || '-'}</div>
                  </div>
              ),
          },
          {
              Header: 'Rol de usuario',
              width: '10%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.role ?? '-'}</div>
                  </div>
              ),
          },
          {
              Header: 'Tipo de Usuario',
              width: '12%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.userType ?? '-'}</div>
                  </div>
              ),
          },
          {
            Header: 'E-mail',
            width: '9%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.email ?? '-'}</div>
                </div>
            ),
        },
          {
              Header: 'Ubicación',
              width: '12%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.location?.name ?? '-'}</div>
                  </div>
              ),
          },
          {
              Header: 'Tipo de Laboratorio',
              width: '12%',
              Cell: ({ row }) => (
                  <div>
                      <div className='text-left'>{row.original.laboratoryType?.name ?? '-'}</div>
                  </div>
              ),
          },
          {
              width: '10%',
              Header: "Acciones",
              Cell: ({ row }) => (
                <div className="page-title-box d-flex align-items-center justify-content-center">
                  <input
                    type="checkbox"
                    checked={row.original.checked ?? false}
                    className="form-check-input rounded-pill p-2"
                    onClick={ () => {
                      console.log("Operative checkbox clicked! Row:", row.original);
                      stableHandleActionButtons(row.original);
                    }}
                    onChange={() => {}}
                  />
                </div>
              ),
          },
      ],
      [stableHandleActionButtons]
  )

  const toggle = () => {
    setShowModal(!showModal);
  }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                type="button"
                onClick={() => onClosed()}
                outline
                color="success"
                className="me-2"
                icon="mdi-content-save"
                label="Aceptar"
            />
            <BaseCustomButton
                type="button"
                onClick={() => onClosed(true)}
                outline
                color="danger"
                className="me-4"
                icon="mdi-close-circle-outline"
                label="Eliminar usuarios"
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">{modalHeader}</h4>
            </label>
        </div>
    );

    const childrenBody = (
        <>
            <GradientDecorationLine />

            <Card className="mx-4">
                <Nav tabs className="nav-tabs-custom nav-justified">
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => profiletoggle("1")}
                        >
                            Personal Operativo
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => profiletoggle("2")}
                        >
                            Asesor Técnico
                        </NavLink>
                    </NavItem>
                </Nav>

                {/* Tabs de contenido */}
                <TabContent activeTab={activeTab} className="p-4">
                    <TabPane tabId="1">
                        <div>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    onSearchOperatives(e.target.inputSearchData.value);
                                }}
                            >
                                <div className="row">
                                    <div className="col-9 col-sm-9 col-md-9">
                                        <input
                                            type="search"
                                            className="form-control rounded-3 text-primary"
                                            placeholder="Buscar"
                                            aria-label="Search"
                                            name="inputSearchData"
                                        />
                                    </div>
                                    <div className="col-3 col-sm-3 col-md-3">
                                    <BaseCustomButton
                                        type="submit"
                                        color="dark"
                                        fullWidth
                                        className="py-2"
                                        icon="mdi-magnify"
                                        label="Buscar"
                                    />
                                    </div>
                                </div>
                            </Form>

                            <Table1
                                currentPage={currentPage}
                                getPagination={getPaginationOp}
                                total={total}
                                loading={loading}
                                retrieveRowInfo={retrieveRowInfo}
                                isAddTableBorderStrap
                                columns={columns}
                                data={pivotOperatives}
                            />

                            <TableItemDeleteModal
                                onDeleteConfirmation={onDeleteConfirmation}
                                props={props}
                                setShowModal={setShowModal2}
                                showModal={showModal2}
                                modalHeader="Eliminar usuarios"
                                modalBodyLabel="¿Está seguro que desea eliminar el usuario seleccionado?"
                            />
                        </div>
                    </TabPane>

                    <TabPane tabId="2">
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                onSearchTechAdvisors(e.target.inputSearchData.value);
                            }}
                        >
                            <div className="row">
                                <div className="col-9 col-sm-9 col-md-9">
                                    <input
                                        type="search"
                                        className="form-control rounded-3 text-primary"
                                        placeholder="Buscar"
                                        aria-label="Search"
                                        name="inputSearchData"
                                    />
                                </div>
                                <div className="col-3 col-sm-3 col-md-3">
                                <BaseCustomButton
                                    type="submit"
                                    color="dark"
                                    fullWidth
                                    className="py-2"
                                    icon="mdi-magnify"
                                    label="Buscar"
                                />
                                </div>
                            </div>
                        </Form>

                        <Table1
                            currentPage={adviserCurrentPage}
                            getPagination={getPaginationTech}
                            total={adviserTotal}
                            loading={loading}
                            retrieveRowInfo={retrieveRowInfo2}
                            isAddTableBorderStrap
                            columns={columns2}
                            data={pivotTechAdv}
                        />

                        <TableItemDeleteModal
                            onDeleteConfirmation={onDeleteConfirmation}
                            props={props}
                            setShowModal={setShowModal4}
                            showModal={showModal4}
                            modalHeader="Eliminar asesores técnicos"
                            modalBodyLabel="¿Está seguro que desea eliminar el asesor técnico seleccionado?"
                        />
                    </TabPane>
                </TabContent>
            </Card>

            <GradientDecorationLine />
        </>
    );

    return (
        <>
            <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                children={childrenBody}
                width="80%" 
                footer={buttons}
            />
        </>
    )

}
